import { z } from "zod";

export const termsAndConditionsSchema = z.object({
  termsAndConditions: z.boolean().refine((value) => value === true, {
    message: "You must agree to the terms and conditions",
  }),
  guardian_name: z.string().optional(),
});

export const namesAndEmailSchema = z.object({
  name: z
    .string()
    .min(1, "First name is required")
    .max(30, "First name can’t be longer than 30 characters."),
  last_name: z
    .string()
    .min(1, "Last name is required")
    .max(30, "Last name can’t be longer than 30 characters."),
  email: z
    .string()
    .email("Please provide a valid email address.")
    .max(70, "Email can’t be longer than 70 characters."),
});

export const teamMemberNamesAndEmailSchema = z.object({
  name: z.string().min(1, "First name is required"),
  last_name: z.string().min(1, "Last name is required"),
  email: z.string().email("Please provide a valid email address."),
});

export type TermsAndConditionsSchemaType = z.infer<
  typeof termsAndConditionsSchema
>;
export type NamesAndEmailSchemaType = z.infer<typeof namesAndEmailSchema>;
export type TeamMemberNamesAndEmailSchemaType = z.infer<
  typeof teamMemberNamesAndEmailSchema
>;
